module.exports = __webpack_public_path__ + "static/media/vitez_website.311f9234.png";